import styled from 'styled-components';

import { TableFilterDropdown } from './TableFilterDropdown';

export const TableFilterDropdownStyled = styled(TableFilterDropdown)`
  padding: 1rem;

  input {
    width: 12rem;
    display: block;
    margin-bottom: 0.5rem;
  }
`;
